import { NgModule } from '@angular/core';
import { CommonModule  } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';


// RUTAS
import { AppRoutingModule } from './app-routing.module';

//PrimeNG

import {MessageService} from 'primeng/api';
import {ConfirmationService} from 'primeng/api';


// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './components/shared/login/login.component';
import { FloginComponent } from './components/shared/flogin/flogin.component';
import { RequestComponent } from './components/shared/request/request.component';


// REDUX
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

// ReduxOperation
import { effectsArray } from './store/effects';
import { appReducers } from './store/app.reducer';

// Environment
import { environment } from 'src/environments/environment.prod';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { NavbarComponent } from './components/shared/navbar/navbar.component';
import { AngularResizedEventModule } from 'angular-resize-event';


@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    FloginComponent,
    DashboardComponent,
    NavbarComponent, 
    RequestComponent
  ],
  imports: [
    BrowserModule,
    AngularResizedEventModule,
    CommonModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    FormsModule ,
    ReactiveFormsModule,
    HttpClientModule,
    StoreModule.forRoot(appReducers),
    EffectsModule.forRoot(effectsArray),
    StoreDevtoolsModule.instrument({
      maxAge: 25,
      logOnly: environment.production,
    })
  ],
  providers: [
    MessageService,
    ConfirmationService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
